import { render, staticRenderFns } from "./GroupSwitcher.vue?vue&type=template&id=1d1ea856"
import script from "./GroupSwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupSwitcher.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports